<template>
    <div>
        <div id="aia_header" 
            :class="[{'aia-header-mass': theme == 'mass'}, 
            {'aia-header-prestige': theme == 'prestige'},
            {'aia-header-mobile': isMobileOS}]">
            <MassHeaderText
                :headerText="headerText"
                :showSearch="showSearch"
                :isShowShare="isShowShare"
                :isShowClose="isShowClose"
                :isShowBlack="isShowBlack"
                v-if="theme == 'mass'"
                @clickBack="clickBack()"
                @clickShare="clickShare()"
                @clickClose="clickClose()" />
            <PrestigeHeaderText
                :headerText="headerText"
                :showSearch="showSearch"
                :isShowShare="isShowShare"
                :isShowClose="isShowClose"
                :isShowBlack="isShowBlack"
                v-if="theme == 'prestige'"
                @clickBack="clickBack()"
                @clickShare="clickShare()"
                @clickClose="clickClose()" />
        </div>
    </div>
</template>
<script>
import MassHeaderText from './component/MassHeaderText.vue';
import PrestigeHeaderText from './component/PrestigeHeaderText.vue';
import Util from '@/helper/Utility.js';

export default {
    name: 'AIAHeaderText',
    components: {
        MassHeaderText,
        PrestigeHeaderText
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    data: function() {
        return {
            isMobileOS: false
        };
    },
    created: function() {
        // check OS is Android or iOS
        var osName = Util.getOsName();
        this.isMobileOS = (osName === 'Android');
        // this.isMobileOS = (osName === 'Android' || osName === 'iOS');
    },
    props: {
        headerText: String,
        showSearch: {type:Boolean, default:false},
        isShowShare: {type:Boolean, default:false},
        isShowClose: {type:Boolean, default:false},
        isShowBlack: {type:Boolean, default:true},
    },
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        },
        clickShare: function () {
            this.$emit('clickShare');
        },
        clickClose: function () {
            this.$emit('clickClose');
        }
    }
}
</script>
